/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/Refresh
 */
export interface RefreshRequestBuilder extends BaseRequestBuilder<RefreshRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(requestConfiguration?: RequestConfiguration<RefreshRequestBuilderPostQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<RefreshRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface RefreshRequestBuilderPostQueryParameters {
    id?: number;
}
/**
 * Uri template for the request builder.
 */
export const RefreshRequestBuilderUriTemplate = "{+baseurl}/Allotment/Refresh?id={id}";
/**
 * Metadata for all the requests in the request builder.
 */
export const RefreshRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RefreshRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
